import { create } from "zustand"
import { ProfileCommunity } from "@/app/entities/BFF/ProfileShort"

interface FollowersState {
  followers: ProfileCommunity[]
  setFollowers: (data: ProfileCommunity[]) => void
  clearFollowers: () => void
  addFollower: (follower: ProfileCommunity) => void
  deleteFollower: (id: string) => void
  isLoading: boolean | null
  setIsLoading: (loading: boolean) => void
  hasMore: boolean
  setHasMore: (hasMore: boolean) => void
}

export const useFollowersStore = create<FollowersState>((set) => ({
  followers: [],
  setFollowers: (data) => set({ followers: data }),
  clearFollowers: () => set({ followers: [], isLoading: null }),
  addFollower: (follower) =>
    set((state) => ({
      followers: [...state.followers, follower],
    })),
  deleteFollower: (id) =>
    set((state) => ({
      followers: state.followers.filter((follower) => follower.id !== id),
    })),
  isLoading: null,
  setIsLoading: (loading) => set({ isLoading: loading }),
  hasMore: true,
  setHasMore: (hasMore) => set({ hasMore: hasMore }),
}))
